import { render, staticRenderFns } from "./LogoKfz24SmallSvg.vue?vue&type=template&id=350c8285"
import script from "./LogoKfz24SmallSvg.vue?vue&type=script&lang=js"
export * from "./LogoKfz24SmallSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports